/**
 * The box opener's controls before an open (the rule is in `storefrontCopy/shared.ts`): the
 * quantity and Open, as the storefront's idle hero (`BoxIdleHero`) and the theme preview's
 * stand-in opener (`SampleOpener`) both draw them. Platform words, the same on every store.
 */
export const OPENER_IDLE_CONTROLS = {
  quantity: "How many to open",
  /** Signed out, an open is a demo. */
  openDemo: "Open a demo",
  /** Paid before the open: a box bought as a product. */
  openPrepaid: "Open",
  /** Given the total for the quantity, formatted. */
  openFor: (total: string) => `Open for ${total}`,
  fastOpen: "Fast open",
} as const;
